import { HomeAlertOutlineIcon } from './HomeAlertOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 0A46973B-0029-4BCF-9728-F3E13DC9FE91
 * name home-alert-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-alert-outline.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 */
export const HouseAlertOutlineIcon = HomeAlertOutlineIcon;
export default HouseAlertOutlineIcon